module.exports = __webpack_public_path__ + "img/1.d24cd451.svg";